import BACKEND_URL from "./config";

export async function fetchPublicConfig() {
  const r = await fetch(`${BACKEND_URL}/public-config`);
  if (!r.ok) throw new Error("Failed to load public-config");
  return r.json();
}

export function formatMoney(value, currency) {
  const cur = (currency || "ARS").toUpperCase();
  return new Intl.NumberFormat(cur === "USD" ? "en-US" : "es-AR", {
    style: "currency",
    currency: cur,
    maximumFractionDigits: cur === "USD" ? 2 : 0,
  }).format(Number(value || 0));
}
